import { activateUserSession, isEmpty, setError } from '../../../library/Core/SmartFunctions';
import { canShowBenefits } from '../alumni-profile/service/student-profile-view.service';

export const navigateToNextStep = async (currentStep, state, dispatch, sessionState, sessionDispatch) => {
    const user_id = state.routeInfo.id;

    let userStatusCode = 'ACTIVE';
    if (sessionState?.userTypeCode == 'SUPER_ADMIN') {
        state?.data?.userInstitutes.map((institute) => {
            if (institute.userStatusCode != 'ACTIVE') {
                userStatusCode = institute.userStatusCode;
            }
        });
    }

    if ((sessionState?.userTypeCode == 'SUPER_ADMIN' || sessionState?.userTypeCode == 'INSTITUTE_ADMIN') && userStatusCode == 'ACTIVE') {
        return state.actions['REDIRECT'](`/alumni/${user_id}/profile`);
    }

    if (sessionState?.userTypeCode != 'SUPER_ADMIN' && sessionState?.userStatusCode == 'ACTIVE') {
        return state.actions['REDIRECT'](`/alumni/${sessionState.id}/profile`);
    }

    let nextStepRoute = '';
    switch (currentStep) {
        // case 'login':
        //     nextStepRoute = findNextStepUrlForLogin(state);
        //     break;

        case 'info':
            await findNextStepUrlForBasicInfo(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;
        
        case 'program-basic-info':
            await findNextStepUrlForProgramBasicInfo(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;
        
        case 'school-higher-studies':
            await findNextStepUrlForSchoolHigherStudies(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;
        
        case 'ug-higher-studies':
            await findNextStepUrlForUgHigherStudies(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;
        
        case 'pg-higher-studies':
            await findNextStepUrlForPgHigherStudies(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;

        case 'outcome':
            await findNextStepUrlForOutcome(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;

        case 'student-took-a-break':
            await findNextStepUrlForBreak(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;

        case 'ug':
            await findNextStepUrlForUg(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;

        case 'pg':
            await findNextStepUrlForPg(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;

        case 'student-school':
            await findNextStepUrlForSchool(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;

        // case 'scholarship':
        //     nextStepRoute = findNextStepUrlForScholarship(state, dispatch, sessionState, sessionDispatch);
        //     break;

        case 'entrance-test':
            await findNextStepUrlForEntranceTest(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;

        case 'entrance-exam':
            await findNextStepUrlForEntranceExam(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;

        case 'student-preference':
            await findNextStepUrlForStudentPreference(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;

        case 'work':
            await findNextStepUrlForWork(state, dispatch, sessionState, sessionDispatch).then((data) => {
                nextStepRoute = data;
            });
            break;
        case 'job-preferences':
                await findNextStepUrlForStudentPreference(state, dispatch, sessionState, sessionDispatch).then((data) => {
                    nextStepRoute = data;
        });
        break;
        // case 'higher_education-preference':
        //     nextStepRoute = findNextStepUrlForHigherEducationPreference(state, dispatch, sessionState, sessionDispatch);
        //     break;
        // case 'job-preferences':
        //     nextStepRoute = findNextStepUrlForJobPreferences(state, dispatch, sessionState, sessionDispatch);
        //     break;
        // case 'achievements':
        //     nextStepRoute = findNextStepUrlForAchievements(state, dispatch, sessionState, sessionDispatch);
        //     break;
        // case 'mentoring-interests':
        //     nextStepRoute = findNextStepUrlForMentoringInterests(state, dispatch, sessionState, sessionDispatch);
        //     break;
        // case 'profile-picture':
        //     nextStepRoute = findNextStepUrlForProfilePicture(state, dispatch, sessionState, sessionDispatch);
        //     break;
        default:
            const domain = !isEmpty(localStorage.getItem('school_settings'))
                ? JSON.parse(localStorage.getItem('school_settings'))?.domain
                : 'miles';
            return state.actions['ROUTER_NAVIGATE'](`/user/${domain}/login`);
    }

    return state.actions['REDIRECT'](`/alumni/${user_id}/${nextStepRoute}`);
};

// const findNextStepUrlForLogin = (state) => 'info';

// const findNextStepUrlForBasicInfo = (state) => 'ug';

// const findNextStepUrlForUg = (state) => 'pg';

// const findNextStepUrlForPg = (state) => 'scholarship';

// const findNextStepUrlForScholarship = (state) => 'entrance-test';

// const findNextStepUrlForEntranceTest = (state) => 'work';

// const findNextStepUrlForWork = (state) => 'higher-education-preference';

// const findNextStepUrlForHigherEducationPreference = (state) => 'job-preferences';

// const findNextStepUrlForJobPreferences = (state) => 'achievements';

// const findNextStepUrlForAchievements = (state) => 'mentoring-interests';

// const findNextStepUrlForMentoringInterests = (state) => 'profile-picture';

// const findNextStepUrlForProfilePicture = (state) => '/';

const findNextStepUrlForLogin = async (state, dispatch, sessionState, sessionDispatch) => 'info';

const findNextStepUrlForBasicInfo = async (state, dispatch, sessionState, sessionDispatch) => 'program-basic-info';

const findNextStepUrlForOutcome = async (state, dispatch, sessionState, sessionDispatch) => {
    return 'profile';
};


const findNextStepUrlForSchoolHigherStudies = async (state, dispatch, sessionState, sessionDispatch) => {
    const selectedInstitute = state?.data?.selectedInstitute;
    console.log("selectedInstitute in navigator", selectedInstitute);
    const postProgramCompletionStatusCode = selectedInstitute?.postProgramCompletionStatusCode;
    if (isEmpty(postProgramCompletionStatusCode)) {
        return 'outcome';
    }
    return await checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForUgHigherStudies = async (state, dispatch, sessionState, sessionDispatch) => {
    const selectedInstitute = state?.data?.selectedInstitute;
    console.log("selectedInstitute in navigator", selectedInstitute);
    const postProgramCompletionStatusCode = selectedInstitute?.postProgramCompletionStatusCode;
    if (isEmpty(postProgramCompletionStatusCode)) {
        return 'outcome';
    }
    return await checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForPgHigherStudies = async (state, dispatch, sessionState, sessionDispatch) => {
    const selectedInstitute = state?.data?.selectedInstitute;
    const postProgramCompletionStatusCode = selectedInstitute?.postProgramCompletionStatusCode;
    if (isEmpty(postProgramCompletionStatusCode)) {
        return 'outcome';
    }
    return await checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForProgramBasicInfo = async (state, dispatch, sessionState, sessionDispatch) => {
    return await checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForBreak = async (state, dispatch, sessionState, sessionDispatch) => {
    return await checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForUg = async (state, dispatch, sessionState, sessionDispatch) => {
    return await checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForPg = async (state, dispatch, sessionState, sessionDispatch) => {
    return await checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForSchool = async (state, dispatch, sessionState, sessionDispatch) => {
    return await checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForScholarship = async (state, dispatch, sessionState, sessionDispatch) => 'entrance-test';

const findNextStepUrlForEntranceTest = async (state, dispatch, sessionState, sessionDispatch) => {
    return checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForEntranceExam = async (state, dispatch, sessionState, sessionDispatch) => {
    return checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForStudentPreference = async (state, dispatch, sessionState, sessionDispatch) => {
    return checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForWork = async (state, dispatch, sessionState, sessionDispatch) => {
    return checkPendingMandatory(state, dispatch, sessionState, sessionDispatch);
};

const findNextStepUrlForHigherEducationPreference = async (state, dispatch, sessionState, sessionDispatch) => 'job-preferences';

const findNextStepUrlForJobPreferences = async (state, dispatch, sessionState, sessionDispatch) => 'achievements';

const findNextStepUrlForAchievements = async (state, dispatch, sessionState, sessionDispatch) => 'mentoring-interests';

const findNextStepUrlForMentoringInterests = async (state, dispatch, sessionState, sessionDispatch) => 'profile-picture';

const findNextStepUrlForProfilePicture = async (state, dispatch, sessionState, sessionDispatch) => '/';

const checkPendingMandatory = async (state, dispatch, sessionState, sessionDispatch) => {
    let pageSlug = 'profile';
    const errorMessages = [];
  
    console.log("state in navigator", state);
    // check work data;
    const workStatusList = ['WORKING_FOR_A_COMPANY'];
    // const schoolArr = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
    // const isCurrentJobExists = state?.data?.jobs?.some((job) => job.isOutcome === true || (job.isOutcome !== true && job.isCurrent === true));
    // const isEntreprenurshipExists = state?.data?.entreprenurship && typeof state.data.entreprenurship === 'object'
    // ? state.data.entreprenurship.isCurrent === true
    // : Array.isArray(state?.data?.entreprenurship)
    //   ? state.data.entreprenurship.some((entreprenurship) => entreprenurship.isCurrent === true)
    //   : false;

    //   const isTeachingAndResearchExists = Array.isArray(state?.data?.teachingWork)
    //   ? state.data.teachingWork.some(teachingWork => teachingWork.isCurrent == true)
    //   : false;

    // const isProfessionalPractExists = state?.data?.professionalPractice && typeof state.data.professionalPractice === 'object'
    //     ? state.data.professionalPractice.isCurrent == true
    //     : Array.isArray(state?.data?.professionalPractice)
    //       ? state.data.professionalPractice.some((professionalPractice) => professionalPractice.isCurrent == true)
    //       : false;
    
    // const isDefenceExists = Array.isArray(state?.data?.defenceWork)
    //       ? state.data.defenceWork.some(defenceWork => defenceWork.isCurrent == true)
    //       : false;

    const selectedInstitute = state?.data?.selectedInstitute;
    const userStatusCode = selectedInstitute?.userStatusCode;
    const workingStatusCode = state?.data?.profile?.workingStatusCode;
    const presentEducationStatusCode = state?.data?.profile?.presentEducationStatusCode;
    const pursuingEducationLevelCode = state?.data?.profile?.pursuingEducationLevelCode;
    const postProgramCompletionStatusCode = selectedInstitute?.postProgramCompletionStatusCode;
    let currentActivityStartYear = '';
    if (workingStatusCode && workingStatusCode !== 'NOT_WORKING') {
        const currentJob = state?.data?.jobs?.find(job => job.isCurrent === true);
        if (currentJob && currentJob.startYear) {
            currentActivityStartYear = currentJob.startYear;
        }
    } else if (presentEducationStatusCode === 'PURSUING_STUDIES') {
        if (pursuingEducationLevelCode === 'UG') {
            const currentUgEducation = state?.data?.underGradCollegeJoined;
            if (currentUgEducation && currentUgEducation.startYear) {
                currentActivityStartYear = currentUgEducation.startYear;
            }
        } else if (pursuingEducationLevelCode === 'PG' || pursuingEducationLevelCode === 'Doctoral') {
            const currentPgEducation = state?.data?.postGradCollegeJoined?.[0];
            if (currentPgEducation && currentPgEducation.startYear) {
                currentActivityStartYear = currentPgEducation.startYear;
            }
        }
     }

     const workMap = {
        'WORKING_FOR_A_COMPANY': {
            'url': 'work',
            'dataKey': 'jobs'
        },
        // 'ENTREPRENEURSHIP': {
        //     'url': 'entrepreneurship',
        //     'dataKey': 'entreprenurship'
        // },
        'TEACHING_AND_RESEARCH': {
            'url': 'teaching-experience',
            'dataKey': 'teachingWork'
        },
        'PROFESSIONAL_PRACTICE': {
            'url': 'professional-practice-experience',
            'dataKey': 'professionalPractice'
        },
        'IN_DEFENCE': {
            'url': 'defence-experience',
            'dataKey': 'defenceWork'
        },
        'SELF_EMPLOYED_AND_FREELANCING': {
            'url': 'freelancing-experience',
            'dataKey': 'freelancing'
        }
    };
    
    if (
        userStatusCode == "PROFILE_IN_PROGRESS" && workMap.hasOwnProperty(workingStatusCode)
        && (
            !state?.data?.[workMap[workingStatusCode].dataKey] 
            || isEmpty(state?.data?.[workMap[workingStatusCode].dataKey])
            || !Array.isArray(state?.data?.[workMap[workingStatusCode].dataKey])
            || !state?.data?.[workMap[workingStatusCode].dataKey]?.some(item => item.isCurrent == true)
        )
    ) {
        pageSlug = `${workMap[workingStatusCode].url}/current`;
    } else if (workingStatusCode === 'ENTREPRENEURSHIP' && isEmpty(state?.data?.entreprenurship)) {
        pageSlug = `entrepreneurship/current`;
    } else if (userStatusCode == "PROFILE_IN_PROGRESS" && presentEducationStatusCode == 'PURSUING_STUDIES' && pursuingEducationLevelCode == 'UG' && (isEmpty(state?.data?.underGradCollegeJoined) || state?.data?.underGradCollegeJoined.length <= 0 || (isEmpty(state?.data?.underGradCollegeJoined?.fieldOfStudyCode) && isEmpty(state?.data?.underGradCollegeJoined?.otherFieldOfStudyCode)))) {
        pageSlug = 'ug-higher-studies';
    } else if (userStatusCode == "PROFILE_IN_PROGRESS" && presentEducationStatusCode == 'PURSUING_STUDIES' && (pursuingEducationLevelCode == 'PG' || pursuingEducationLevelCode == 'Doctoral') && (isEmpty(state?.data?.postGradCollegeJoined) || state?.data?.postGradCollegeJoined.length <= 0 || (isEmpty(state?.data?.postGradCollegeJoined?.[0]?.fieldOfStudyCode) && isEmpty(state?.data?.postGradCollegeJoined?.[0]?.otherFieldOfStudyCode)))) {
        pageSlug = 'pg-higher-studies';
    } else if (userStatusCode == "PROFILE_IN_PROGRESS" && presentEducationStatusCode == 'PURSUING_STUDIES' && pursuingEducationLevelCode && ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'].includes(pursuingEducationLevelCode) && (isEmpty(state?.data?.schools) || state?.data?.schools?.length <= 0)) {
        pageSlug = 'school-higher-studies';
    } else if (isEmpty(postProgramCompletionStatusCode)) {
        pageSlug = 'outcome';
    // } else if (!isEmpty(postProgramCompletionStatusCode) && currentActivityStartYear - selectedInstitute?.passOutYear > 2) {
    //     pageSlug = 'outcome';
    // } else if (postProgramCompletionStatusCode === 'PREPARING_FOR_EXAM') {
    //     pageSlug = 'entrance-exam';
    // } else if (postProgramCompletionStatusCode === 'JOB_HUNTING') {
    //     pageSlug = 'student-preference';
    // } else if (postProgramCompletionStatusCode === 'HIGHER_STUDIES') {
    //     pageSlug = 'higher-education-preference';
    // } else if (postProgramCompletionStatusCode === 'TOOK_A_BREAK' || postProgramCompletionStatusCode === 'TAKE_BREAK') {
    //     pageSlug = 'student-took-a-break';
    // } else if (postProgramCompletionStatusCode === 'JOINED_UG') { // ALUMNI CASES
    //     pageSlug = 'ug/outcome';
    // } else if (postProgramCompletionStatusCode === 'JOINED_PG') {
    //     pageSlug = 'pg/outcome';
    // } else if (postProgramCompletionStatusCode === 'JOINED_DOCTORAL') {
    //     pageSlug = 'pg/outcome';
    // } else if (postProgramCompletionStatusCode === 'APPEARED_FOR_COMPETITIVE_EXAM') {
    //     pageSlug = 'entrance-exam';
    // } else if (postProgramCompletionStatusCode === 'JOINED_COMPANY') {
    //     pageSlug = 'work/outcome';
    } else if (workStatusList.includes(state?.data?.profile?.workingStatusCode) &&
        (isEmpty(state?.data?.jobs) || state?.data?.jobs?.length <= 0 ) 
    ) {
        pageSlug = 'work';
    }else if(state?.data?.profile?.workingStatusCode==="ENTREPRENEURSHIP" &&
        // (isEmpty(state?.data?.entreprenurship) || state?.data?.entreprenurship?.length <= 0)
        isEmpty(state?.data?.entreprenurship)
    ){
        pageSlug = 'entrepreneurship';
    }else if(state?.data?.profile?.workingStatusCode==="TEACHING_AND_RESEARCH" &&
        (isEmpty(state?.data?.teachingWork) || state?.data?.teachingWork?.length <= 0)
    ){
        pageSlug = 'teaching-experience';
    }else if(state?.data?.profile?.workingStatusCode==="PROFESSIONAL_PRACTICE" &&
        (isEmpty(state?.data?.professionalPractice) || state?.data?.professionalPractice?.length <= 0 )
    ){
        pageSlug = 'professional-practice-experience';
    }else if(state?.data?.profile?.workingStatusCode==="IN_DEFENCE" &&
        (isEmpty(state?.data?.defenceWork) || state?.data?.defenceWork?.length <= 0 )
    ){
        pageSlug = 'defence-experience';
    }else if(state?.data?.profile?.workingStatusCode==="SELF_EMPLOYED_AND_FREELANCING" && (isEmpty(state?.data?.freelancing) || state?.data?.freelancing?.length <= 0)){
        pageSlug = 'freelancing-experience';
    }else if (state?.data?.profile?.presentEducationStatusCode == 'PURSUING_STUDIES') {
        switch (state?.data?.profile?.pursuingEducationLevelCode) {
            case 'UG':
                if (isEmpty(state?.data?.underGradCollegeJoined) || state?.data?.underGradCollegeJoined.length <= 0) {
                    pageSlug = 'ug';
                }
                break;

            case 'PG':
            case 'Doctoral':
                if (isEmpty(state?.data?.postGradCollegeJoined) || state?.data?.postGradCollegeJoined.length <= 0) {
                    pageSlug = 'pg';
                } else if (isEmpty(state?.data?.underGradCollegeJoined) || state?.data?.underGradCollegeJoined.length <= 0) {
                    pageSlug = 'ug';
                }
                break;

            // default:
            //     if (schoolArr.includes(state?.data?.profile?.pursuingEducationLevelCode)) {
            //         if ( isEmpty (state?.data?.schoolOutComesDetail) || state?.data?.schoolOutComesDetail.length <= 0 ) {
            //             pageSlug = 'student-school';
            //         }
            //     }
            //     break;
        }
    } else if (state?.data?.profile?.presentEducationStatusCode == 'COMPLETED_STUDIES') {
        if (state?.data?.profile?.workingStatusCode == 'NOT_WORKING' && state?.data?.profile?.preparingForExam && !state?.data?.entranceTests?.some(test => !isEmpty(test.preparationStatusCode)) ) {
            pageSlug = 'entrance-exam';
        }

        switch (state?.data?.profile?.highestCompletedEducationLevelCode) {
            case 'UG':
                if (isEmpty(state?.data?.underGradCollegeJoined) || state?.data?.underGradCollegeJoined.length <= 0) {
                    pageSlug = 'ug';
                }
                break;

            case 'PG':
            case 'Doctoral':
                if (isEmpty(state?.data?.postGradCollege) || state?.data?.postGradCollege.length <= 0) {
                    pageSlug = 'pg';
                }
                break;

            // default:
            //     if (schoolArr.includes(state?.data?.profile?.highestCompletedEducationLevelCode)) {
            //         if ( isEmpty (state?.data?.schoolOutComesDetail) || state?.data?.schoolOutComesDetail.length <= 0 ) {
            //             pageSlug = 'student-school';
            //         }
            //     }
            //     break;
        }
    }

    if (pageSlug == 'profile') {
        await activateUserSession(sessionState, sessionDispatch);
        if (sessionState?.tabType != 'STUDENT' && canShowBenefits(state)) {
            pageSlug = `benefits`;
        }
    }

    return pageSlug;
};
